import type { TfMemory } from '../types/tf-types'
import useData from './data-service'

export default function useStoryCard(): TfMemory | undefined {
  const data = useData()
  if (!data) return undefined
  return data?.popularStory
}
